import { render } from "./basetime.vue?vue&type=template&id=bf511fa4&scoped=true"
import script from "./basetime.vue?vue&type=script&lang=js"
export * from "./basetime.vue?vue&type=script&lang=js"

import "./basetime.vue?vue&type=style&index=0&id=bf511fa4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf511fa4"]])

export default __exports__